import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"
import _ from "lodash"
import { hideSavingDisplay, showSavingDisplay } from "../components/saving_display"

// Connects to data-controller="ajaxform"
export default class extends Controller {
  static targets = [ "validationField" ]

  connect() {
    const debounceDelay = this.element.dataset.type == "http" ? 1600 : 1000;
    const debounced_submit = _.debounce(() => {
      showSavingDisplay()
      if (this.element.dataset.type == "http") {
        this.element.submit();
      } else {
        Rails.fire(this.element, "submit");
      }
    }, debounceDelay)

    this.element.addEventListener('keyup', () => {
      debounced_submit()
    });

    this.element.addEventListener('change', () => {
      debounced_submit()
    });

    this.element.addEventListener('ajax:success', () => {
      hideSavingDisplay()
      this.clearValidationFields()
    });

    this.element.addEventListener('ajax:error', (event) => {
      hideSavingDisplay()
      this.clearValidationFields()
      const [data, status, xhr] = event.detail

      const fieldWithErrors = Object.keys(data)
      fieldWithErrors.forEach((field) => {
        const errorMessages = data[field]
        const validationField = document.querySelector(`[data-ajaxform-field="${field}"]`)
        validationField.innerText = this.arrayToHTML(errorMessages)
      })
    });
  }

  arrayToHTML(arrayOfString) {
    let html = ""
    arrayOfString.forEach((string) => {
      html += `● ${_.capitalize(string)}\r\n`
    })
    return html
  }

  clearValidationFields() {
    this.validationFieldTargets.forEach((field) => {
      field.innerText = ""
    })
  }
}
